"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter = _interopRequireDefault(require("lodash/filter"));
var _map = _interopRequireDefault(require("lodash/map"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _without = _interopRequireDefault(require("lodash/without"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _FormattedComponents = require("../FormattedComponents");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _TwinPanelPickerComponent; //components
//styles
//messages
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var MAX_NR_OF_SELECTED_ITEMS = 50;
var TwinPanelPickerComponent = (0, _mobxReact.observer)(_class = (_class2 = (_TwinPanelPickerComponent = /*#__PURE__*/function (_Component) {
  function TwinPanelPickerComponent(props) {
    var _this;
    _classCallCheck(this, TwinPanelPickerComponent);
    _this = _callSuper(this, TwinPanelPickerComponent, [props]);
    _initializerDefineProperty(_this, "query", _descriptor, _this);
    _initializerDefineProperty(_this, "selectedByKeyboardIndex", _descriptor2, _this);
    _defineProperty(_this, "scrollableAreaRef", null);
    _defineProperty(_this, "searchBoxRef", null);
    _defineProperty(_this, "focus", function () {
      if (_this.searchBoxRef) {
        _this.searchBoxRef.select();
      }
    });
    _defineProperty(_this, "handleDeselectAll", function () {
      var _this$props = _this.props,
        onDeselect = _this$props.onDeselect,
        selectedOptions = _this$props.selectedOptions,
        valueAccessor = _this$props.valueAccessor;
      var values = (0, _map["default"])(selectedOptions, valueAccessor);
      onDeselect(values);
    });
    _defineProperty(_this, "keyDownHandlers", {
      ArrowDown: function ArrowDown() {
        _this.setSelectedByKeyboardIndex(_this.selectedByKeyboardIndex + 1);
      },
      ArrowUp: function ArrowUp() {
        _this.setSelectedByKeyboardIndex(_this.selectedByKeyboardIndex - 1);
      },
      Home: function Home() {
        _this.setSelectedByKeyboardIndex(0);
      },
      End: function End() {
        var lastIndex = _this.filteredLeftOptions.length - 1;
        _this.setSelectedByKeyboardIndex(lastIndex);
      },
      Enter: function Enter() {
        var _this$props2 = _this.props,
          onDeselect = _this$props2.onDeselect,
          onSelect = _this$props2.onSelect,
          selectedOptions = _this$props2.selectedOptions,
          valueAccessor = _this$props2.valueAccessor;
        var leftOption = _this.filteredLeftOptions[_this.selectedByKeyboardIndex];
        if (leftOption) {
          var value = valueAccessor(leftOption);
          if (selectedOptions.includes(leftOption)) {
            onDeselect([value]);
          } else {
            onSelect([value]);
          }
        }
        _this.focus();
      }
    });
    _defineProperty(_this, "handleKeyDown", function (event) {
      if (_this.keyDownHandlers[event.key]) {
        event.stopPropagation();
        event.preventDefault();
        _this.keyDownHandlers[event.key]();
      }
    });
    _defineProperty(_this, "handleOptionClickFactory", function (option, onSelect, isDisabled) {
      return function () {
        if (isDisabled) {
          return;
        }
        var valueAccessor = _this.props.valueAccessor;
        var value = valueAccessor(option);
        onSelect([value]);
      };
    });
    _defineProperty(_this, "handleSelectAll", function () {
      var _this$props3 = _this.props,
        onSelect = _this$props3.onSelect,
        valueAccessor = _this$props3.valueAccessor;
      var values = (0, _map["default"])(_this.availableOptions, valueAccessor);
      onSelect(values);
    });
    _defineProperty(_this, "handleSelectFiltered", function () {
      var _this$props4 = _this.props,
        onSelect = _this$props4.onSelect,
        valueAccessor = _this$props4.valueAccessor;
      var values = (0, _map["default"])(_this.filteredLeftOptions, valueAccessor);
      onSelect(values);
    });
    _defineProperty(_this, "handleTextboxInput", function (event) {
      var onSearch = _this.props.onSearch;
      _this.setQuery(event.target.value);
      _this.setSelectedByKeyboardIndex(0);
      if (onSearch) onSearch(event.target.value);
    });
    _defineProperty(_this, "renderOptions", function (options, shouldBeSelectableByKeyboard, shouldDisableAvailableOptions) {
      var _this$props5 = _this.props,
        mode = _this$props5.mode,
        labelAccessor = _this$props5.labelAccessor,
        labelFormatter = _this$props5.labelFormatter,
        onDeselect = _this$props5.onDeselect,
        onSelect = _this$props5.onSelect,
        selectedOptions = _this$props5.selectedOptions,
        valueAccessor = _this$props5.valueAccessor;
      return options.map(function (option, index) {
        var isSelected = selectedOptions.includes(option);
        var onClick = isSelected ? onDeselect : onSelect;
        return /*#__PURE__*/_react["default"].createElement(_styles.Option, {
          isDisabled: shouldDisableAvailableOptions,
          isSelectedByKeyboard: !shouldDisableAvailableOptions && shouldBeSelectableByKeyboard && _this.selectedByKeyboardIndex === index,
          key: valueAccessor(option),
          onClick: _this.handleOptionClickFactory(option, onClick, shouldDisableAvailableOptions),
          "data-testid": "option-".concat(option.name.split(' ').join('-'))
        }, mode === 'single' && /*#__PURE__*/_react["default"].createElement(_styles.CheckmarkIcon, {
          isVisible: isSelected
        }), labelFormatter(_this.renderLabel(labelAccessor(option), shouldBeSelectableByKeyboard), option));
      });
    });
    _defineProperty(_this, "renderLabel", function (string, shouldBeSelectableByKeyboard) {
      if (!_this.query || !shouldBeSelectableByKeyboard) {
        return string;
      }
      var startIndex = string.toLowerCase().indexOf(_this.query);
      if (startIndex === -1) {
        return string;
      }
      var endIndex = startIndex + _this.query.length;
      return /*#__PURE__*/_react["default"].createElement("span", null, string.slice(0, startIndex), /*#__PURE__*/_react["default"].createElement(_styles.Highlight, null, string.slice(startIndex, endIndex)), string.slice(endIndex));
    });
    _defineProperty(_this, "scrollToSelectedByKeyboardOption", function () {
      window.requestAnimationFrame(function () {
        var element = _this.scrollableAreaRef && _this.scrollableAreaRef.querySelector('.select-dropdown-keyboard-focus');
        if (!element) {
          return;
        }
        element.scrollIntoView({
          block: 'nearest'
        });
      });
    });
    _initializerDefineProperty(_this, "setSelectedByKeyboardIndex", _descriptor3, _this);
    _initializerDefineProperty(_this, "setQuery", _descriptor4, _this);
    _defineProperty(_this, "setScrollableAreaRef", function (scrollableAreaRef) {
      _this.scrollableAreaRef = scrollableAreaRef;
    });
    _defineProperty(_this, "setSearchBoxRef", function (searchBoxRef) {
      _this.searchBoxRef = searchBoxRef;
    });
    _defineProperty(_this, "handleScroll", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var onScrollToBottom = _this.props.onScrollToBottom;
      if (!onScrollToBottom) return;
      var bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      if (bottom) {
        onScrollToBottom();
      }
    });
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(TwinPanelPickerComponent, _Component);
  return _createClass(TwinPanelPickerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document.activeElement) {
        document.activeElement.blur();
      }
      this.focus();
      this.scrollToSelectedByKeyboardOption();
    }
  }, {
    key: "availableOptions",
    get: function get() {
      var _this$props6 = this.props,
        options = _this$props6.options,
        selectedOptions = _this$props6.selectedOptions;
      return _without["default"].apply(void 0, [options].concat(_toConsumableArray(selectedOptions)));
    }
  }, {
    key: "filteredLeftOptions",
    get: function get() {
      var _this2 = this;
      var _this$props7 = this.props,
        labelAccessor = _this$props7.labelAccessor,
        lazyLoad = _this$props7.lazyLoad;
      if (lazyLoad) return this.leftOptions;
      return (0, _filter["default"])(this.leftOptions, function (option) {
        return labelAccessor(option).toLowerCase().includes(_this2.query);
      });
    }
  }, {
    key: "leftOptions",
    get: function get() {
      var _this$props8 = this.props,
        mode = _this$props8.mode,
        options = _this$props8.options;
      if (mode === 'twin') {
        return this.availableOptions;
      }
      return options;
    }
  }, {
    key: "rightOptions",
    get: function get() {
      var selectedOptions = this.props.selectedOptions;
      if (mode === 'twin') {
        return selectedOptions;
      }
      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
        className = _this$props9.className,
        mode = _this$props9.mode,
        intl = _this$props9.intl,
        onCommit = _this$props9.onCommit,
        rows = _this$props9.rows,
        selectedOptions = _this$props9.selectedOptions,
        style = _this$props9.style,
        title = _this$props9.title,
        customMessages = _this$props9.customMessages,
        onSearch = _this$props9.onSearch,
        searchTerm = _this$props9.searchTerm,
        lazyLoad = _this$props9.lazyLoad;
      var formatMessage = intl.formatMessage;
      var selectedMessage = customMessages && customMessages.selected ? customMessages.selected : _messages["default"].selected;
      var deselectAllMessage = customMessages && customMessages.deselectAll ? customMessages.deselectAll : _messages["default"].deselectAll;
      var shouldShowSelectFilteredButton = Boolean(this.filteredLeftOptions.length && this.filteredLeftOptions.length !== this.leftOptions.length && MAX_NR_OF_SELECTED_ITEMS - (selectedOptions.length + this.filteredLeftOptions.length) >= 0);
      var shouldDisableAvailableOptions = selectedOptions.length === MAX_NR_OF_SELECTED_ITEMS;
      var filteredLeftOptions = this.filteredLeftOptions.length ? this.renderOptions(this.filteredLeftOptions, true, shouldDisableAvailableOptions) : lazyLoad ? /*#__PURE__*/_react["default"].createElement(_styles.Notice, null, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].noResultsFound)) : /*#__PURE__*/_react["default"].createElement(_styles.Notice, null, this.query && this.leftOptions.length && /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].noResultsFound));
      return /*#__PURE__*/_react["default"].createElement(_styles.TwinPanelPicker, {
        className: className,
        onClick: this.focus,
        onKeyDown: this.handleKeyDown,
        style: style
      }, title && /*#__PURE__*/_react["default"].createElement(_styles.HeaderSection, null, title), /*#__PURE__*/_react["default"].createElement(_styles.MainSection, null, /*#__PURE__*/_react["default"].createElement(_styles.Column, {
        isRelative: true
      }, /*#__PURE__*/_react["default"].createElement(_styles.SearchBox, {
        value: onSearch ? searchTerm : this.query,
        "data-testid": 'twin-panel-search-box',
        onChange: this.handleTextboxInput,
        placeholder: formatMessage(_messages["default"].searchPlaceholderText),
        ref: this.setSearchBoxRef
      }), /*#__PURE__*/_react["default"].createElement(_styles.SearchIcon, null), /*#__PURE__*/_react["default"].createElement(_styles.ScrollableArea, {
        ref: this.setScrollableAreaRef,
        rows: rows,
        onScroll: this.handleScroll
      }, shouldDisableAvailableOptions && /*#__PURE__*/_react["default"].createElement(_styles.Notice, null, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, _messages["default"].itemsInfo, {
        values: {
          itemsNumber: MAX_NR_OF_SELECTED_ITEMS
        }
      }))), filteredLeftOptions)), mode === 'twin' && /*#__PURE__*/_react["default"].createElement(_styles.Column, null, /*#__PURE__*/_react["default"].createElement(_styles.Heading, null, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, selectedMessage)), /*#__PURE__*/_react["default"].createElement(_styles.ScrollableArea, {
        rows: rows
      }, this.renderOptions(selectedOptions, false)))), /*#__PURE__*/_react["default"].createElement(_styles.FooterSection, null, mode === 'twin' && /*#__PURE__*/_react["default"].createElement(_styles.ShortcutActions, null, shouldShowSelectFilteredButton && /*#__PURE__*/_react["default"].createElement(_styles.StyledSelectionButton, {
        onClick: this.handleSelectFiltered
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, _messages["default"].selectFilteredItems, {
        values: {
          count: this.filteredLeftOptions.length
        }
      })))), /*#__PURE__*/_react["default"].createElement(_styles.StyledFooterButtons, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledSelectionButton, {
        disabled: !selectedOptions.length,
        onClick: this.handleDeselectAll
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, deselectAllMessage)), /*#__PURE__*/_react["default"].createElement(_styles.StyledDoneButton, {
        onClick: onCommit,
        "data-testid": 'apply-button'
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].apply)))));
    }
  }]);
}(_react.Component), _defineProperty(_TwinPanelPickerComponent, "defaultProps", {
  mode: 'twin',
  options: [],
  labelAccessor: function labelAccessor(option) {
    return option.label;
  },
  labelFormatter: function labelFormatter(highlightedLabel) {
    return highlightedLabel;
  },
  onCommit: _noop["default"],
  onDeselect: _noop["default"],
  onSelect: _noop["default"],
  rows: 5.5,
  selectedOptions: [],
  valueAccessor: function valueAccessor(option) {
    return option.value;
  },
  lazyLoad: false,
  onSearch: undefined,
  onScrollToBottom: undefined,
  searchTerm: undefined
}), _defineProperty(_TwinPanelPickerComponent, "propTypes", {
  mode: _propTypes["default"].oneOf(['twin', 'single']),
  options: _propTypes["default"].arrayOf(_propTypes["default"].object),
  labelAccessor: _propTypes["default"].func,
  labelFormatter: _propTypes["default"].func,
  onCommit: _propTypes["default"].func,
  onDeselect: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  rows: _propTypes["default"].number,
  selectedOptions: _propTypes["default"].arrayOf(_propTypes["default"].object),
  title: _propTypes["default"].string,
  valueAccessor: _propTypes["default"].func,
  lazyLoad: _propTypes["default"].bool,
  onSearch: _propTypes["default"].func,
  onScrollToBottom: _propTypes["default"].func,
  searchTerm: _propTypes["default"].string
}), _TwinPanelPickerComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "query", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedByKeyboardIndex", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return -1;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "filteredLeftOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredLeftOptions"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "setSelectedByKeyboardIndex", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (selectedByKeyboardIndex) {
      var maxIndex = _this3.filteredLeftOptions.length - 1;
      if (selectedByKeyboardIndex < 0) {
        selectedByKeyboardIndex = maxIndex;
      } else if (selectedByKeyboardIndex > maxIndex) {
        selectedByKeyboardIndex = 0;
      }
      _this3.selectedByKeyboardIndex = selectedByKeyboardIndex;
      _this3.scrollToSelectedByKeyboardOption();
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "setQuery", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (query) {
      _this4.query = query.toLowerCase();
    };
  }
})), _class2)) || _class;
var _default = exports["default"] = (0, _reactIntl.injectIntl)(TwinPanelPickerComponent);
//# sourceMappingURL=index.js.map